/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { EsignFileAttachment } from './EsignFileAttachment';
